(() => {
  const CONTAINER_SELECTOR = '#szb-container';
  const ANCHOR_SELECTOR = '#ProductSelect-option-0';
  const PICKER_SELECTOR = 'variant-picker[data-product-block]';
  const OBSERVER_TIMEOUT_MS = 15000;

  let observer;

  const disconnectObserver = () => {
    if (!observer) return;

    observer.disconnect();
    observer = undefined;
  };

  const stabilizeContainer = () => {
    const container = document.querySelector(CONTAINER_SELECTOR);
    const anchor = document.querySelector(ANCHOR_SELECTOR);
    const picker = anchor?.closest(PICKER_SELECTOR);

    if (!container || !picker) return false;

    if (picker.contains(container)) {
      picker.after(container);
    }

    const isStable = !picker.contains(container);

    if (isStable) disconnectObserver();

    return isStable;
  };

  const startObserver = () => {
    if (stabilizeContainer()) return;

    observer = new MutationObserver(stabilizeContainer);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(disconnectObserver, OBSERVER_TIMEOUT_MS);
  };

  window.addEventListener('sizebay:rendered', stabilizeContainer);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver, { once: true });
  } else {
    startObserver();
  }
})();
